const standard = () => 
`
  <Tag name="Standard Tag" />
`;

const draggable = () => 
`
  <DraggableTag name="Draggable Tag" />
`;

const filter = () => 
`
  <FilterTag name="Filter Tag" />
`;

const toggle = () => 
`
  <ToggleTag tags={{}} />
`;

const tagsTemplates = {
  standard: standard(),
  draggable: draggable(),
  filter: filter(),
  toggle: toggle()
};


export default tagsTemplates;


// WEBPACK FOOTER //
// ./src/containers/elements/Tags/constants/tagsTemplates.js